export const SHOW_PARAMS = [ "cost", "revenue", "roi", "factor", "lastFactor", "adjustment" ];


// WEBPACK FOOTER //
// ./src/scenes/AdkBidFactor/config.js